import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";

export function QueryParamsManagerDashboard() {
    const { activeEndDate, activeStartDate } = useAppSelector(state => state.dashboardAdminPage);

    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams((params) => {
            if (activeEndDate) {
                params.set("endDate", activeEndDate)
            } else {
                params.delete("endDate")
            }

            if (activeStartDate) {
                params.set("startDate", activeStartDate)
            } else {
                params.delete("startDate")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activeEndDate, activeStartDate]);

    return <></>
}